import React, { useContext } from 'react';
import { LayoutContext } from '@rsos/components/capstone/base/Layout';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import Login from '../../Auth/Login';
import { MainHeader, Subheader } from '../Landing.styles.js';
import {
  FirstRowWrapper,
  FirstRowContentWrapper,
  FirstRowTextBox,
  FirstRowDescription,
} from './FirstRow.styles.js';

const FirstRow = () => {
  const { layout } = useContext(LayoutContext);

  return (
    <FirstRowWrapper>
      <FirstRowContentWrapper>
        <FirstRowTextBox>
          {layout.window.width > BP_LAPTOP && (
            <Subheader>RAPIDSOS PORTAL</Subheader>
          )}
          <MainHeader
            textAlign={layout.window.width > BP_LAPTOP ? 'left' : 'center'}
          >
            Life-saving data when you need it
          </MainHeader>
          {layout.window.width > BP_LAPTOP && (
            <FirstRowDescription>
              An Emergency Communication Center’s portal to all data from
              RapidSOS. The platform provides intelligent, real-time data to
              first responders to support a faster and smarter emergency
              response.
            </FirstRowDescription>
          )}
        </FirstRowTextBox>
        <Login />
      </FirstRowContentWrapper>
    </FirstRowWrapper>
  );
};

export default FirstRow;
